import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import next from "../../assets/nextIcon.svg";
import prev from "../../assets/previousIcon.svg";
import { Container, IconButton, Skeleton } from "@mui/material";
import OtherStoreInfoCard from "./OtherStoreInfoCard";
import "./ProductDetails.css"; // Add your custom CSS here

type Props = {
  otherRetailersData: any[];
};

const OtherAvailableStores: React.FC<Props> = ({ otherRetailersData }) => {
  const [storeData, setStoreData] = useState<any[]>([]);

  useEffect(() => {
    setStoreData(otherRetailersData);
  }, [otherRetailersData]);

  const CustomPrevArrow: React.FC = (props) => (
    <div {...props} className="custom-prev-arrow-retailers">
      <IconButton
        disableRipple
        aria-label="previous slider"
        sx={{
          "&:hover": { backgroundColor: "transparent" },
        }}
      >
        <img
          id="previous-icon"
          alt="previous icon"
          src={prev}
          className="arrow-styles-retailers"
        />
      </IconButton>
    </div>
  );

  const CustomNextArrow: React.FC = (props) => (
    <div {...props} className="custom-next-arrow-retailers">
      <IconButton
        disableRipple
        aria-label="next slider"
        sx={{
          "&:hover": { backgroundColor: "transparent" },
        }}
      >
        <img
          id="next-icon"
          alt="next icon"
          src={next}
          className="arrow-styles-retailers"
        />
      </IconButton>
    </div>
  );

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: storeData.length >= 4 ? 4 : storeData.length,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: storeData.length >= 3 ? 3 : storeData.length,
          slidesToScroll: 1,
        },
      },
      /*   {
        breakpoint: 1024,
        settings: {
          slidesToShow: storeData.length >= 3 ? 3 : storeData.length,
          slidesToScroll: 1,
          dots: true,
        },
      }, */
      {
        breakpoint: 900,
        settings: {
          slidesToShow: storeData.length >= 2 ? 2 : storeData.length,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: storeData.length >= 2 ? 2 : storeData.length,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Container maxWidth="xl" className="container">
      {storeData.length === 0 ? (
        <Skeleton
          variant="rounded"
          width="100%"
          height={300}
          animation="wave"
        />
      ) : (
        <Slider {...settings}>
          {storeData.map((store) => (
            <div key={store.id} style={{ padding: "0 10px" }}>
              <OtherStoreInfoCard otherStoreData={store} />
            </div>
          ))}
        </Slider>
      )}
    </Container>
  );
};

export default OtherAvailableStores;
